import { i18n } from "services/i18nService";
import { fulfillmentTransactionIsValid } from "services/sosInventoryService/fulfillmentTransaction/isValid";
import { quantitySerialsIsValid } from "services/utility/isValid";

export function isValid(record, relatedRecords, lines) {
  let errors = fulfillmentTransactionIsValid(record, relatedRecords, lines);

  // is associated with a customer
  if (typeof record.customer?.id !== "number") {
    errors.messages.push(i18n("isValid.Customer"));
    errors.entity.push("customer");
  }

  errors = quantitySerialsIsValid(errors, lines);
  return errors;
}
